import axios from "./productInstance";

const getProductBundleItems = async (bundleId: string): Promise<any | null> => {
    try {
        const response = await axios.get(`/bundles/${bundleId}`);
        return {
            ...response.data,
            bundle_items: response.data.bundle_items.map((item: any) => ({
                ...item,
                is_product_profile_active: true,
            })).sort((a: any, b: any) => a.id.localeCompare(b.id))
        };
    } catch (error: any) {
        console.error("Error fetching product bundle items:", error?.response?.data || error.message);
        return null;
    }
};

export default getProductBundleItems;
